import { CheckboxField, RichTextField } from "components/RenderInput"
import React from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, FieldArray } from "redux-form"
import { renderReminderNotifications } from "./utils"

const CommuniationTab = () => {
  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>COMMUNICATION</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" className="mt-1">
              <label>Reminder Notifications:</label>
            </Col>
            <Col xs="auto">
              <FieldArray
                name="reminderNotifications"
                component={renderReminderNotifications}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs="auto">
              <label>Email Booking Confirmation:</label>
            </Col>
          </Row>
          <Row>
            <Col xs="auto">
              <Field name="emailConfirmation" component={RichTextField} />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Field
                name="addQR"
                component={CheckboxField}
                label="Add Unique QR Upon Purchase"
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default CommuniationTab
